<template>
  <div class="form__counter">
    <button type="button" aria-label="Убрать один товар" @click.prevent="decrease()">
      <svg width="12" height="12" fill="currentColor">
        <use xlink:href="#icon-minus"></use>
      </svg>
    </button>

    <input type="number" :value="productAmount" @input="changeAmount($event.target.value)">

    <button type="button" aria-label="Добавить один товар" @click.prevent.number="increase()">
      <svg width="12" height="12" fill="currentColor">
        <use xlink:href="#icon-plus"></use>
      </svg>
    </button>
  </div>
</template>

<script>

export default {
  props: ['productAmount'],

  model: {
    prop: 'productAmount',
    event: 'changeAmount',
  },
  methods: {
    changeAmount(productAmount) {
      this.$emit('changeAmount', productAmount)
    },
    decrease() {
      if (this.productAmount > 1) {
        this.$emit('changeAmount', this.productAmount - 1)
      }
    },
    increase() {
      this.$emit('changeAmount', this.productAmount + 1)
    }
  }
}
</script>
